<script setup>
import { computed } from 'vue';

const props = defineProps({
    modelValue: {
        type: String,
        required: true,
    },
    options: {
        type: Array,
        required: true,
    },
});

const emit = defineEmits(['update:modelValue']);

const selectedIndex = computed(() =>
    Math.max(
        0,
        props.options.findIndex((option) => option.value === props.modelValue),
    ),
);

// Indicator geometry derived from the container's p-1 (0.25rem) padding: each cell
// spans (100% - 0.5rem) / n, and the indicator shifts one cell width per index.
const indicatorStyle = computed(() => {
    const count = props.options.length;

    return {
        width: `calc((100% - 0.5rem) / ${count})`,
        left: `calc(0.25rem + ${selectedIndex.value} * (100% - 0.5rem) / ${count})`,
    };
});

const gridStyle = computed(() => ({
    gridTemplateColumns: `repeat(${props.options.length}, minmax(0, 1fr))`,
}));
</script>

<template>
    <div :style="gridStyle" class="relative inline-grid rounded-xl border border-slate-200 bg-slate-100 p-1 shadow-inner">
        <div :style="indicatorStyle" class="absolute inset-y-1 rounded-lg bg-white shadow-sm transition-all duration-300" />
        <button
            v-for="option in options"
            :key="option.value"
            type="button"
            class="relative z-10 px-4 py-2 text-center text-sm font-medium transition-colors duration-300"
            :class="modelValue === option.value ? 'text-primary' : 'text-slate-400'"
            @click="emit('update:modelValue', option.value)"
        >
            <span class="line-clamp-2">{{ option.label }}</span>
        </button>
    </div>
</template>
